import type { BonusGroup, BonusItemGeneral } from 'api/cms/bonuses';

import type { CMSGameCover } from 'api/cms/gameCovers';
import type { GameCovers } from 'contexts/addons/index';
import { filter, flatten, map, mergeAll, pipe } from 'ramda';

export const sortCovers = (covers: CMSGameCover[]): GameCovers =>
  pipe<CMSGameCover[], GameCovers[], GameCovers>(
    map(({ gameId, cover }) => ({
      [gameId]: { cover },
    })),
    mergeAll
  )(covers);

export const bonusesToDepositCodes = (bonuses: BonusItemGeneral[]): string[] =>
  pipe<BonusItemGeneral[], BonusItemGeneral[], string[]>(
    filter((bonus: BonusItemGeneral) => !!bonus.code),
    map(({ code }) => code || '')
  )(bonuses);

export const bonusGroupsToDepositCodes = (bonuses: BonusGroup[]): any[] =>
  pipe<BonusGroup[], BonusItemGeneral[][], string[][], string[]>(
    map(({ bonuses }) => bonuses),
    map(bonusesToDepositCodes),
    flatten
  )(bonuses);
